import { Pagination as WebUiPagination } from '@zopauk/web-ui';

type PaginationProps = {
  currentPage: number;
  totalPages: number;
  basePath: string;
};

export const Pagination = ({ currentPage, totalPages, basePath }: PaginationProps) => (
  <WebUiPagination
    renderLink={(pageNumber) => `?page=${pageNumber}`}
    currentPage={currentPage}
    totalPages={totalPages}
    basePath={basePath}
  />
);
